import { create } from 'zustand'
import { searchAll } from '../api/search'
import { SearchResult } from '../helpers/types/search'

export interface SearchState {
	searchAll: (query: string, type: string) => Promise<SearchResult>
}

export const searchStore = create<SearchState>((set) => ({
	searchAll: async (query, type) => {
		const data = await searchAll(query, type)
		return data
	}
}))
